const FileContainer = ({ children }) => {
  return (
    <div className="flex flex-col p-3 bg-four rounded-xl border w-full h-auto relative">
      {children}
    </div>
  );
};

export default FileContainer;
